import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { Table } from 'semantic-ui-react';

import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import FromToDatePicker from '../../../components/FromToDatepicker';
import Loader from '../../../components/Loader';

import user from '../../../store/user';

import { getUnmappedPaidRecruiters } from '../../../services/getUnmappedPaidRecruiters';


import './styles.scss';
import { adminFeatureMapping } from '../../../models/adminFeatureMapping';

/**
 * Dashboard which has the following functions:
 * 1. show all recruiters who have posted atleast one job within the selected given time frame and are not associated
 *    with any verified companies
 * 2. user can verify a company from this dashboard.
 * 3. the verify modal will have the option to change the unverified company 
 * 4. verify modal will show the list of recruiters associated with the selected unverified company
 * 5. verify modal will confirm before taking any action
 */
const UnmappedActiveRecruiters = props => {

    const [adminId, setAdminId] = useState(null);

    const [recruiters, setRecruiters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    const [dateRange, setDateRange] = useState({
        startDate: moment().subtract(15, 'days').startOf('day').toDate(),
        endDate: moment().startOf('day').toDate(),
        error: null,
    });

    const tableHeading = (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell width="one">Recruiter ID</Table.HeaderCell>
                <Table.HeaderCell width="one">Email</Table.HeaderCell>
                <Table.HeaderCell width="one">Domain</Table.HeaderCell>
                <Table.HeaderCell width="one">Jobs</Table.HeaderCell>
                <Table.HeaderCell width="one" className="actions">Actions</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
    );

    // get list of recruiters with the following conditions:
    // 1. company_id in recruiter_profile is null
    // 2. company_id in recruiter_verification_status == 0 and unverified_company_id in recruiter_verification_status != 0
    // 3. has posted atleast one job in the selected date range
    const getRecruiterList = async (start = null, end = null) => {
        try {

            console.log("Caalleed");
            let from = dateRange.startDate;
            let to = dateRange.endDate;

            if (start) from = start;
            if (end) to = end;

            const params = {
                from: `${moment(from).format('YYYY-MM-DD')} 00:00:00`,
                to: `${moment(to).format('YYYY-MM-DD')} 00:00:00`,
            };

            const response = await getUnmappedPaidRecruiters(adminId, params);

            if (response && response.status == 200) {
                if (response.data && response.data.data) {
                    setRecruiters(Object.values(response.data.data));
                }
            }
        } catch (error) {
            console.log(error);
        }

        setIsLoading(false);
        setIsPageLoading(false);
    };


    // when user clicks search button
    const handleOnSearch = () => {
        setIsLoading(true);
        getRecruiterList();
    };

    useEffect(() => {

        if (adminId) {
            setIsLoading(true);
            getRecruiterList(dateRange.startDate, dateRange.endDate);
        }
    }, [adminId]);


    // fetch admin details on page load
    useEffect(() => {
        async function getProfile() {
            const profile = await user.getProfile();

            return profile;
        }

        getProfile().then(data => {
            if (!user.checkFeatureAccess(adminFeatureMapping.COMPANY_MODERATION)) {
                window.location.href = '/notAdmin'
            }

            setAdminId(data.id);
        })
    }, []);


    let mainContent;

    if (isLoading) {
        mainContent = (
            <Loader />
        );
    } else if (!isLoading && (!recruiters || recruiters.length === 0)) {
        mainContent = (
            <div>No records found!</div>
        );
    } else {
        mainContent = (
            <Table className="recruiter__table">
                {tableHeading}
                <Table.Body>
                    {
                        recruiters.map((item, index) => {
                            return (
                                <Table.Row className="recruiter__table--row">
                                    <Table.Cell verticalAlign="top">{item.id}</Table.Cell>
                                    <Table.Cell verticalAlign="top">{item.email}</Table.Cell>
                                    <Table.Cell verticalAlign="top">{item.domain}</Table.Cell>
                                    <Table.Cell verticalAlign="top">{item.jobs.map(i => <><a style={{ display: "block" }} target='__blank' href={`/editjob/${i.metaId}`} >{i.title}</a><br/></>)}</Table.Cell>
                                    <Table.Cell verticalAlign="top">
                                        <a target='__blank' href={`/recruiter/recruiter_profile_mgtedit?recid=${item.id}`}>Edit Profile</a>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })
                    }
                </Table.Body>
            </Table>
        )
    };

    return (
        <div className='page-content active-rec-unverified-comp'>

            <div className='page-heading'>
                <Heading text="Unmapped Paid Recruiters" />
            </div>

            <div className='controller__container'>
                <div className='controller__container--left'>
                    <div className='control'>
                        <div className='label'>
                            Date:
                        </div>
                        <FromToDatePicker
                            name="date"
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                            handleChangeStart={value => {
                                setDateRange({
                                    ...dateRange,
                                    startDate: moment(value).toDate(),
                                });
                            }}
                            handleChangeEnd={value => {
                                setDateRange({
                                    ...dateRange,
                                    endDate: moment(value).toDate(),
                                });
                            }}
                        />
                    </div>
                    <div className='actions'>
                        <Button
                            className="btn-search"
                            text="Search"
                            skin={'dark'}
                            clickButton={handleOnSearch}
                            disabled={dateRange.error ? true : null}
                        />
                    </div>
                </div>
                <span style={{
                    background: "#f1f1f1",
                    padding: "8px 11px",
                    borderRadius: "5px",
                    fontSize: "13px",
                    fontWeight: "bold"
                }} className='controller__container--right'>Count: {recruiters.length}</span>
                {dateRange.error ? <div className='error'>Date range cannot be more than 1 month</div> : null}
            </div>

            <div className='main-content'>
                {mainContent}
            </div>

        </div>
    );
};

export default UnmappedActiveRecruiters;